module.exports = __webpack_public_path__ + "static/media/buffet13.13b06c9e.jpg";